import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto auto auto auto 1fr;
  position: relative;
`;

export const Content = styled.div`
  overflow: auto;
  overflow-y: overlay;
  height: 100%;
  padding-bottom: 10px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Header = styled.div`
  width: 100%;
  padding: 36px 40px 24px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  color: #1b203a;
  font-size: 24px;
  font-weight: 600;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const Spacing = styled.div`
  margin: 0 40px;
`;

export const Item = styled.div`
  margin: 0 40px;
  cursor: pointer;

  & + & {
    margin-top: 12px;
  }
`;

export const Heading = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 4fr 2fr 3fr 4fr 2fr 2fr 2fr;
  grid-gap: 16px;
  padding: 12px;
  align-items: center;
  justify-content: center;
`;

export const Direction = styled.div`
  margin-left: 8px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

export const ColumnName = styled.div`
  font-size: 12px;
  color: #8f95b2;
  font-weight: 500;
`;

export const Line = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 4fr 2fr 3fr 4fr 2fr 2fr 2fr;
  grid-gap: 16px;
  padding: 12px;
  background: #f5f7fb;
  border-radius: 8px;

  ${(props: { $unreadMessages: boolean }) => {
    return (
      props.$unreadMessages &&
      css`
        border: 1px solid #9db5ff;
        padding: 11px;
      `
    );
  }}

  & + & {
    margin-top: 12px;
  }
`;

export const MenuContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

interface ILineText {
  limitOfLines?: number;
  disabled?: boolean;
}

export const LineText = styled.div<ILineText>`
  color: #474d66;
  font-size: 14px;

  ${({ disabled }) =>
    disabled &&
    css`
      color: #8f95b2;
    `}

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const LineTextContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const NoText = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-style: italic;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

interface IInputSearch {
  search?: boolean;
  clear?: boolean;
}

export const InputSearch = styled.input<IInputSearch>`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  &::placeholder {
    color: #8f95b2;
  }

  ${({ search }) =>
    search &&
    css`
      padding-right: 66px;
    `}
  ${({ clear }) =>
    clear &&
    css`
      padding-right: 36px;
    `}
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  & span {
    display: inline-flex;
  }
`;

export const LoadMore = styled.div`
  margin-top: 6px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;

export const TabsContainer = styled.div`
  position: relative;
  margin: 16px 40px;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Indicator = styled.div<isActiveProps>`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ isActive }) => (isActive ? '#1371fe' : 'transparent')};
  z-index: 2;
`;

export const Label = styled.div`
  padding-right: 6px;
  padding-left: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div<isActiveProps>`
  white-space: nowrap;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};
`;

export const Back = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #edeff4;
  z-index: 1;
`;

export const ItemTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  & + & {
    margin-left: 48px;
  }
`;

export const Count = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 18px;
  padding: 0 6px;
  background: #edeff4;
  border-radius: 4px;
  margin-left: 10px;
  font-weight: 600;
`;

export const IdentificationRequestsTools = styled.div`
  margin: 16px 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

interface IAssineeWrapper {
  active?: boolean;
}

export const AssineeWrapper = styled.div<IAssineeWrapper>`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 012px;
  height: 42px;
  background: ${({ active }) => (active ? '#1371fe' : '#ffffff')};
  border: 1px solid ${({ active }) => (active ? '#1371fe' : '#d8dae5')};
  border-radius: 8px;
  cursor: pointer;

  & span {
    font-family: 'Poppins' sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 22px;
    color: ${({ active }) => (active ? '#fff' : '#474d66')};
  }
`;

export const AssineeImage = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 11px;
`;

export const ErrorPageWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
  text-align: center;
  padding: 20px;
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  width: 100%;
`;

export const ErrorPageMessage = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;
  margin: unset;
`;

export const CommentBox = styled.div``;
